import { formatCode } from "../../utils";

abstract class WBSRowModel {
  public readonly uid: string;
  public readonly structured: string;
  public rowType: number;
  public quantity: number;
  public unitCost: number;
  public total: number;

  private _codeStructured: string;
  /** Utilizados apenas para manipulação das tabelas */
  public visible: boolean = true;
  public expanded: boolean = false;
  public selected: boolean = false;

  constructor(
    uid: string,
    structured: string,
    rowType: number,
    quantity: number = 0,
    unitCost: number = 0,
    total: number = 0
  ) {
    this.uid = uid;
    this.structured = String(structured);
    this._codeStructured = WBSRowModel.getCodeStructured(String(structured));
    this.rowType = rowType;
    this.quantity = quantity;
    this.unitCost = unitCost;
    this.total = total;
  }

  get codeStructured(): string {
    return this._codeStructured;
  }

  get isStage(): boolean {
    return this.rowType === 0;
  }

  get level(): number {
    return this.structured.split(".").length;
  }

  public abstract canShowAt(page: "contract" | "measurement"): boolean;

  static getCodeStructured(structured: string) {
    return String(structured)
      .split(".")
      .map((num) => {
        return formatCode(num, "0000");
      })
      .join(".");
  }
}

export default WBSRowModel;
